import { ComponentProps, useContext } from 'react';
import Dialog from '@pelckmans/elementis/components/dialog';
import MaterialDialogHeader from '../../../components/MaterialDialogHeader';
import ModalContext from '../../../../../contexts/ModalContext';
import { useTranslation } from 'react-i18next';

type ImagePreviewModalProps = {
  id: string;
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
  downloadUrl?: string;
  image: {
    src: string;
    alt: string;
  };
};

export default function ImagePreviewModal({ id, headerProps, downloadUrl, image }: ImagePreviewModalProps) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  function handleClose() {
    closeModal(id);
  }

  return (
    <Dialog
      id={id}
      modal
      onClose={handleClose}
      size="md"
      className="image-preview-modal"
      aria-label={t('PAGES.TOC_LEVEL.MODALS.IMAGE_PREVIEW.A11Y_LABEL')}
    >
      <MaterialDialogHeader
        title={headerProps.title}
        onClose={handleClose}
        tags={headerProps.tags}
        downloadUrl={downloadUrl}
        titleTooltip={headerProps.titleTooltip}
      />
      <Dialog.Body>
        <div className="container">
          <img src={image.src} alt={image.alt} />
        </div>
      </Dialog.Body>
    </Dialog>
  );
}
